export default __webpack_public_path__ + "static/media/page9Image3_en.8aef939e.jpg";